<template>
    <!-- 今日北向资金 -->
    <section class="mod mod1">
        <!-- <h2 class="mod-tit">
            今日北向资金
            <router-link
                class="fr link-more"
                :to="{ name: 'todaylist', params: { id: 'bxzj' } }"
            >
                查看更多
            </router-link>
        </h2> -->
        <div class="nav-sub flex">
            <span
                v-for="(item, i) in ZJTodayNavs"
                :key="i"
                :class="curZJToday == i ? 'cur' : ''"
                @click="setCav(item, i)"
                >{{ item }}</span
            >
        </div>
        <div class="nav-sub-cont">
            <!-- <div class="chart-legent flex"> -->
                <!-- <span
                    v-for="(title, i) in legents"
                    :class="{
                        'legent-blue': i == 0,
                        'legent-org': i == 1,
                        'legent-red': i == 2,
                    }"
                    :key="i"
                    class="legent"
                    v-show="!(curZJToday == 2 && i == 0)"
                >
                    {{ title }}</span
                > -->

            <!-- </div> -->
            <!-- 北向成交总额 -->
            <div class="chart-info-box">
                <div class="chart-info-date">
                    数据日期：{{ pagealtogether.quotaDate }}
                </div>
                <div class="chart-info flex" v-if="curZJToday==0">
                    <div>
                        <span class="data-tit">沪股通</span>
                        <strong :class="pagealtogether.bx_h_saleTotal | formateRedGreen">{{ pagealtogether.bx_h_saleTotal | formatePrefixData}}</strong></div>
                    <div>
                        <span class="data-tit">深股通</span>
                        <strong :class="pagealtogether.bx_s_saleTotal | formateRedGreen">{{ pagealtogether.bx_s_saleTotal | formatePrefixData}}</strong></div>
                </div>
                <div class="chart-info flex" v-else-if="curZJToday == 1">
                    <div>
                        <span class="data-tit">两市合计</span>
                        <strong :class="pagealtogether.bx_both_total | formateRedGreen">{{ pagealtogether.bx_both_total | formatePrefixDataJiahao}}</strong></div>
                    <div>
                        <span class="data-tit">沪股通</span>
                        <strong :class="pagealtogether.bx_h_bsTotal | formateRedGreen">{{ pagealtogether.bx_h_bsTotal | formatePrefixDataJiahao}}</strong></div>
                    <div>
                        <span class="data-tit">深股通</span>
                        <strong :class="pagealtogether.bx_s_bsTotal | formateRedGreen">{{ pagealtogether.bx_s_bsTotal | formatePrefixDataJiahao}}</strong></div>
                </div>

            </div>
<!--
            <div v-if="showInfo">
                <div class="chart-info flex">
                    <div>
                        两市合计<em @click="dialogVisible=true;"> ⓘ</em><strong :class="lshj | formateRedGreen"
                        >{{ lshj }}亿</strong
                        >
                    </div>
                    <div>
                        沪股通<strong :class="hgt | formateRedGreen"
                        >{{ hgt }}亿</strong
                        >
                    </div>
                    <div>
                        深股通<strong :class="sgt | formateRedGreen"
                        >{{ sgt }}亿</strong
                        >
                    </div>
                </div>
                <div class="chart chart-today" id="line"></div>
            </div>

            <div
                style="
                    height: 1.5rem;
                    text-align: center;
                    line-height: 1.5rem;
                    font-size: 14px;
                    color: #999999;
                "
                v-else
            >
                -暂无数据-
            </div> -->
            <p class="remark">
                说明：<br>
                {{dialogContent[curZJToday]}}
            </p>
                <!-- <div class="chart chart-today" id="line"></div> -->

        </div>
        <!-- 提示窗口 -->
        <div :class="dialogVisible?'dialog-six-mask':'dialog-six-hidden'" @click="closeDialog">
            <div class="dialog-six"  @click.stop="">
                <div class="dialog-six-title">
                    说明
                </div>
                <div class="dialog-six-content">
                    <p style="white-space:pre-line;">
                        ①沪股通和深股通每日额度各为{{pagealtogether.bx_buyTotal}}亿元人币，两市合计额度{{pagealtogether.bx_buyTotal * 2}}亿人民币；</br>②当日额度余额大于或等于30%时，显示“额度充足”；小于30%时，实时显示额度余额。
                    </p>
                </div>
                <div class="dialog-six-footer">
                    <span @click="closeDialog">我知道了</span>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
// import Vue from 'vue'
import { bxzjmin, bxzjyemin, getYunSpjToSf } from "@/api/index.js";
import { mapState } from "vuex";

export default {
    name: "TodayNorthAmount",
    data() {
        return {
            pageoldJlrItem:{},
            indexJyzt:'',
            pagealtogether:{
                bx_buyTotal:0,
                bx_both_total:0,
                nx_both_total:0,
                bx_h_bsTotal: 0,
                bx_h_saleTotal: 0,
                bx_s_bsTotal: 0,
                bx_s_saleTotal: 0,
                nx_h_bsTotal: 0,
                nx_h_saleTotal: 0,
                nx_s_bsTotal: 0,
                nx_s_saleTotal: 0,

                bx_h_total :0, // 北向净买额
                bx_s_total:0, // 北向净买额
                bx_s_h_total:0, // 北向总净买额
            },
            curZJToday: 0,
            ZJTodayNavs: [ "额度余额","成交总额"],
            // ZJTodayNavs: ["资金流向", "资金净流入", "额度余额", "未成交委买"],
            legents: ["合计", "沪股通", "深股通"],
            showLineMore: false,
            LineMoreIndex: 0,
            LineMoreArray: ["上证指数", "深证成指", "创业板指", "沪深300"],
            setZsTitle: "上证指数",

            bxzj_zjlx: [], //北向资金资金流向
            hgt_zjlx: [], //资金流向  沪股通
            sgt_zjlx: [], //资金流向  深股通
            bxzj_jlr: [], //北向资金净流入
            hgt_jlr: [], //沪股通净流入
            sgt_jlr: [], //深股通进流入
            bxzj_wcj: [], //北向资金未成交
            hgt_wcj: [], //沪股通未成交
            sgt_wcj: [], //深股通未成交
            hgt_ye: [], //沪股通余额
            sgt_ye: [], //深股通余额
            desc: [],
            lshj: "",
            hgt: "",
            sgt: "",

            zs: [], //指数

            xDataInfo: [],
            yDataHj: [],
            yDataHgt: [],
            yDataSgt: [],
            yDataZs: [],
            timeInfo: [],
            MINUTES: 260, //沪深一天的交易时间
            AM_MINUTES: 140, //沪深上午交易时间

            showInfo: true,
            dialogVisible: false, // 弹窗显示
            dialogContent: [
                // '资金流向=每日初始限额-每日剩余额度。\n反映当日北向资金的实际使用额度,包含实际成交的净流入额和未成交的委买额。',
                // '资金净流入=当日买入成交总额-当日卖出成交总额。\n反映当日北向资金的实际流入流出情况。',
                // '沪股通和深股通每日额度各为520亿元人民币；港股通的每日限额各为420亿元人民币。\n每日额度减去已使用的额度就是北向和南向资金的金额。',
                // '未成交委买资金=资金流向-资金净流入。\n反映算在当天北向资金使用额度内，但是未实际成交的买单金额。',

                '①沪股通和深股通每日额度各为520亿元人币，两市合计额度1040亿人民币；\n②当日额度余额大于或等于30%时，显示“额度充足”；小于30%时，实时显示额度余额。',
                '每日收市后更新成交总额',
                ],
        };
    },
    filters: {
        formatePrefixDataDe: function (v) {

            if(v==undefined||v==null|| v == '--'|| v == '----' || v== 0){
                return '待更新';
            } else if(v>0){
                return '+'+v+'亿';
            } else if(v<0){
                return v +'亿';
            }else{
                return v;
            }

        },
        formatePrefixData: function (v) {

            if(v==undefined||v==null|| v == '--'|| v == '----' || v== 0){
                return '--';
            } else if(v>0){
                return '+'+(v/100000000).toFixed(2)+'亿';
            } else if(v<0){
                return (v/100000000).toFixed(2) +'亿';
            }else{
                return v;
            }

        },
        formatePrefixDataJiahao: function (v) {
            if(v==undefined||v==null|| v == '--'|| v == '----' || v== 0){
                return '待更新';
            } else if(v>0){
                return (v/100000000).toFixed(2)+'亿';
            } else if(v<0){
                return (v/100000000).toFixed(2) +'亿';
            }else{
                return v;
            }

        },
        formatePrefixDataD: function (v) {
            if(v==undefined||v==null|| v == '--'|| v == '----' || v== 0){
                return '待更新';
            } else if(v>0){
                return '+'+(v/100000000).toFixed(2)+'亿';
            } else if(v<0){
                return (v/100000000).toFixed(2) +'亿';
            }else{
                return v;
            }

        },
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        // formatePrefixData: function (v) {
        //     if (v == undefined || v == null) return "--";
        //     if (v > 0) return "+" + v;
        //     if (v < 0) return v;
        // },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
    },
    computed: {
        ...mapState(["altogether"]),
        ...mapState(["jyzt"]),
        ...mapState(["oldJlrItem"]),
    },
    watch: {
        altogether: {
            deep: true,
            handler () {
                this.pagealtogether = this.$store.state.altogether;
            }
        },
        oldJlrItem: {
            deep: true,
            handler () {
                this.pageoldJlrItem = this.$store.state.oldJlrItem;
            }
        },
        jyzt: {
            deep: true,
            handler () {

                this.indexJyzt = this.$store.state.jyzt;

                if(this.indexJyzt != '交易中'){
                    this.curZJToday = 1;
                }else{
                    this.curZJToday = 0;
                }
            }
        },

    },
    created() {
        for (var i = 0; i <= this.MINUTES; i++) {
            this.timeInfo.push(this.convertXToTime(i));
        }

    },
    mounted: function () {
        var that = this;
        // this.drawLine();
        this.getToDayBxzj();
        this.getToDayZjye();
        console.log('this.$store.state.altogether',this.$store.state.altogether)
        this.pagealtogether = this.$store.state.altogether;

        this.indexJyzt = this.$store.state.jyzt;
        if(this.indexJyzt != '交易中'){
            this.curZJToday = 1;
        }


    },
    methods: {
        addZero: function (str, length) {
            return (
                new Array(length - str.toString().length + 1).join("0") + str
            );
        },
        convertXToTime: function (x) {
            var startAm = new Date(1970, 1, 1, 9, 10, 0);
            var startPm = new Date(1970, 1, 1, 13, 0, 0);
            var endXAm = this.AM_MINUTES; //上午交易时间段对应的最后一个x序列的值(2个小时,120分钟)
            var time = "";
            if (x <= endXAm) {
                time = new Date(+startAm + 60000 * x); //获得当前时间=起始时间 + 1分钟 * X
            } else {
                time = new Date(+startPm + 60000 * (x - endXAm)); //获得当前时间=起始时间 + 1分钟 * (X - 上午最后一个X - 1)
            }

            return [
                this.addZero(time.getHours(), 2),
                this.addZero(time.getMinutes(), 2),
            ].join(":");
        },
        drawLine: function () {
            var _this = this;
            var chartDom = document.getElementById("line");
            var myChart = this.$echarts.init(chartDom);
            var curZJToday = this.curZJToday;
            var option;
            var zs = Object.values(_this.zs);
            var setZsTitle = _this.setZsTitle;
            option = {
                color: ["#1677FF", "#FF6010", "#EA46FF", "#454955"],
                tooltip: {
                    show: true, // 是否显⽰
                    trigger: "axis", // 触发类型  'item'图形触发：散点图，饼图等⽆类⽬轴的图表中使⽤； 'axis'坐标轴触发；'none'：什么都不触发。
                    triggerOn: "mousemove",
                    alwaysShowContent: false,
                    formatter: function (params) {
                        var string = "";
                        if (
                            params[0] !== undefined &&
                            !isNaN(params[0].value)
                        ) {
                            string +=
                                params[0].marker +
                                params[0].seriesName +
                                params[0].value +
                                "亿<br/>";
                        }
                        if (
                            params[1] !== undefined &&
                            !isNaN(params[1].value)
                        ) {
                            string +=
                                params[1].marker +
                                params[1].seriesName +
                                params[1].value +
                                "亿<br/>";
                        }
                        if (
                            params[2] !== undefined &&
                            !isNaN(params[2].value)
                        ) {
                            if (curZJToday == 2) {
                                string +=
                                    params[2].marker +
                                    params[2].seriesName +
                                    params[2].value;
                            } else {
                                string +=
                                    params[2].marker +
                                    params[2].seriesName +
                                    params[2].value +
                                    "亿<br/>";
                            }
                        }
                        if (params[3] !== undefined) {
                            if (!isNaN(params[3].value)) {
                                string +=
                                    params[3].marker +
                                    params[3].seriesName +
                                    params[3].value;
                            }
                        }

                        return string == ""
                            ? false
                            : params[0].name + "<br/>" + string;
                    },
                },

                grid: {
                    left: 0,
                    right: 10,
                    bottom: "3%",
                    top: 25,
                    containLabel: true,
                },

                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: _this.timeInfo,
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                    axisLabel: {
                        color: "#999",
                        //interval: 59,
                        interval: function (index) {
                            //index是x轴的坐标序号，name是坐标值
                            var timeLength = _this.timeInfo.length - 1;
                            if (index == 0) {
                                return true;
                            }
                            if (index == timeLength) {
                                return true;
                            }
                        },
                        textStyle: { color: "#ccc", fontSize: 13 },

                        formatter: function (value, index) {
                            //文本格式化
                            if (index === 0) {
                                return "{right|" + value + "}";
                            } else if (index === 4) {
                                return "{left|" + value + "}";
                            } else {
                                return "{center|" + value + "}";
                            }
                        },
                        rich: {
                            right: {
                                width: 80,
                                fontSize: 10,
                                align: "right",
                            },
                            left: {
                                width: 100,
                                fontSize: 10,
                                align: "left",
                            },
                            center: {
                                fontSize: 10,
                                align: "center",
                            },
                        },
                        padding: [0, 20, 0, 0],
                    },

                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "#C8C8C8",
                        },
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        splitNumber: 5,
                        gridIndex: 0,
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: function (value) {
                                if (value > 10) {
                                    return Math.trunc(value) + "亿";
                                } else {
                                    return value + "亿";
                                }

                                // return value+ "亿";
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                type: "dashed",
                                color: "#C8C8C8",
                            },
                        },
                        min: function (value) {
                            if (curZJToday == 2) {
                                var minInfo = value.min - 10;
                            } else {
                                if (value.min > 0) {
                                    var minInfo = value.min - value.min * 0.2;
                                } else {
                                    var minInfo = value.min + value.min * 0.2;
                                }
                            }

                            return Math.round(minInfo);
                        },
                        max: function (value) {
                            if (curZJToday == 2) {
                                return Math.round(value.max + 10);
                            } else {
                                return Math.round(value.max + value.max * 0.2);
                            }
                        },
                    },
                    {
                        type: "value",
                        alignTicks: true,
                        position: "right",
                        axisLabel: {
                            fontSize: 10,
                            color: "#999",
                            inside: true,
                            verticalAlign: "bottom",
                            margin: 3,
                            padding: [1, 0],
                            formatter: function (value) {
                                return Math.trunc(value);
                            },
                        },
                        splitLine: { show: false },
                        min: function (value) {
                            if (value.min > 0) {
                                var minInfo = value.min - 20;
                            } else {
                                var minInfo = value.min + 20;
                            }

                            return minInfo;
                        },
                        max: function (value) {
                            var maxInfo = value.max + 20;

                            return maxInfo;
                        },
                    },
                ],
                series: [
                    {
                        name: "合计",
                        type: "line",
                        symbol: "none",
                        data: this.yDataHj,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    width: 1.5, // 0.1的线条是非常细的了
                                },
                            },
                        },
                        // data: [120, 132, 101, 134, 90, 230, 210],
                    },
                    {
                        name: "沪股通",
                        type: "line",
                        symbol: "none",
                        // data: [220, 182, 191, 234, 290, 330, 310],
                        data: this.yDataHgt,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    width: 1, // 0.1的线条是非常细的了
                                },
                            },
                        },
                    },
                    {
                        name: "深股通",
                        type: "line",
                        symbol: "none",
                        // data: [150, 232, 201, 154, 190, 330, 410],
                        data: this.yDataSgt,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    width: 1, // 0.1的线条是非常细的了
                                },
                            },
                        },
                    },
                    {
                        name: setZsTitle,
                        type: "line",
                        symbol: "none",
                        yAxisIndex: 1,
                        data: zs,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    width: 1.5, // 0.1的线条是非常细的了
                                },
                            },
                        },
                    },
                ],
            };
            setTimeout(function () {
                myChart.setOption(option);
                window.addEventListener("resize", function () {
                    myChart.resize();
                });

                myChart.dispatchAction({
                    type: "hideTip",
                });
            });
        },

        // 今日北向资金(资金流向,资金净买入,未成交委买)
        getToDayBxzj: function () {
            var _this = this;
            var response = "";
            bxzjmin().then((res) => {
                this.$nextTick(() => {
                    if (res.data.err == 0) {
                        response = res.data.data;
                        // 当数据为空
                        if(response.length == 0) {
                            return false;
                        }

                        var bxzj_zjlx,
                            hgt_zjlx,
                            sgt_zjlx,
                            bxzj_jlr,
                            hgt_jlr,
                            sgt_jlr,
                            bxzj_wcj,
                            hgt_wcj,
                            sgt_wcj;
                        var bxzjLength = response.bxzj.length;
                        if (bxzjLength < 20) {
                            _this.timeInfo = _this.timeInfo.slice(0, 21);
                        }
                        for (var i = 0; i < response.bxzj.length; i++) {
                            //资金流向
                            bxzj_zjlx = (response.bxzj[i] / 100000000).toFixed(
                                2
                            );
                            hgt_zjlx = (response.hgt[i] / 100000000).toFixed(2);
                            sgt_zjlx = (response.sgt[i] / 100000000).toFixed(2);

                            _this.bxzj_zjlx.push(bxzj_zjlx);
                            _this.hgt_zjlx.push(hgt_zjlx);
                            _this.sgt_zjlx.push(sgt_zjlx);

                            //资金净流入
                            bxzj_jlr = (
                                response.bxzj_jlr[i] / 100000000
                            ).toFixed(2);
                            hgt_jlr = (response.hgt_jlr[i] / 100000000).toFixed(
                                2
                            );
                            sgt_jlr = (response.sgt_jlr[i] / 100000000).toFixed(
                                2
                            );
                            _this.bxzj_jlr.push(bxzj_jlr);
                            _this.hgt_jlr.push(hgt_jlr);
                            _this.sgt_jlr.push(sgt_jlr);
                            // 资金未成交
                            bxzj_wcj = (
                                response.bxzj_wcj[i] / 100000000
                            ).toFixed(2);
                            hgt_wcj = (response.hgt_wcj[i] / 100000000).toFixed(
                                2
                            );
                            sgt_wcj = (response.sgt_wcj[i] / 100000000).toFixed(
                                2
                            );

                            _this.bxzj_wcj.push(bxzj_wcj);
                            _this.hgt_wcj.push(hgt_wcj);
                            _this.sgt_wcj.push(sgt_wcj);
                        }
                        _this.desc = response.desc;

                        _this.lshj = (_this.desc.bxzjlr / 100000000).toFixed(2);
                        _this.hgt = (_this.desc.hgt_lr / 100000000).toFixed(2);
                        _this.sgt = (_this.desc.sgt_lr / 100000000).toFixed(2);

                        _this.yDataHj = this.bxzj_zjlx;
                        _this.yDataHgt = this.hgt_zjlx;
                        _this.yDataSgt = this.sgt_zjlx;

                        if (this.bxzj_zjlx.length == 0) {
                            this.showInfo = false;
                        } else {
                            _this.getYunSpj(0);
                            // setTimeout(() => {
                            //     this.$nextTick(() => {
                            //         _this.drawLine();
                            //     });
                            // }, 500);
                        }
                    }
                });
            });
        },
        // 查询北向资金(额度余额)
        getToDayZjye: function () {
            var _this = this;
            var response = "";
            bxzjyemin().then((res) => {
                this.$nextTick(() => {
                    if (res.data.err == 0) {
                        response = res.data.data;
                        var hgt_ye, sgt_ye;
                        for (var i = 0; i < response.hgt_ye.length; i++) {
                            hgt_ye = (response.hgt_ye[i] / 100000000).toFixed(
                                2
                            );
                            sgt_ye = (response.sgt_ye[i] / 100000000).toFixed(
                                2
                            );

                            _this.hgt_ye.push(hgt_ye);
                            _this.sgt_ye.push(sgt_ye);
                        }
                    }
                });
            });
        },
        setCav: function (item, i) {
            this.curZJToday = i;
            this.showInfo = true;
            if (i == 0) {
                this.lshj = (this.desc.bxzjlr / 100000000).toFixed(2);
                this.hgt = (this.desc.hgt_lr / 100000000).toFixed(2);
                this.sgt = (this.desc.sgt_lr / 100000000).toFixed(2);

                this.yDataHj = this.bxzj_zjlx;
                this.yDataHgt = this.hgt_zjlx;
                this.yDataSgt = this.sgt_zjlx;
                this.yDataZs = this.zs;
                if (this.yDataHj.length == 0) {
                    this.showInfo = false;
                } else {
                    // this.drawLine();
                }
            }  else if (i == 1) {
                this.hgt = (this.desc.hgt_ye / 100000000).toFixed(2);
                this.sgt = (this.desc.sgt_ye / 100000000).toFixed(2);
                this.lshj = (
                    (this.desc.sgt_ye + this.desc.hgt_ye) /
                    100000000
                ).toFixed(2);
                //余额
                this.yDataHj = [];
                this.yDataHgt = this.hgt_ye;
                this.yDataSgt = this.sgt_ye;
                this.yDataZs = this.zs;
                if (this.yDataHgt.length == 0) {
                    this.showInfo = false;
                } else {
                    // this.drawLine();
                }
            }
        },

        setZs: function (title, i) {
            var _this = this;
            this.LineMoreIndex = i;
            this.setZsTitle = title;
            this.getYunSpj(i);
            // setTimeout(function () {
            //     _this.drawLine();
            // }, 1000);
        },

        // 获取云平台资金流向K线
        getYunSpj: function (i) {
            var obj = "SH000001";
            if (i == 0) {
                // 上证
                obj = "SH000001";
            } else if (i == 1) {
                // 深证
                obj = "SZ399001";
            } else if (i == 2) {
                //创业板指
                obj = "SZ399006";
            } else {
                obj = "SH000300";
            }

            var myDate = new Date();
            var response = "";
            function vertDate(obj) {
                //日期转yyyy-MM-dd
                var date = new Date(obj);
                var y = 1900 + date.getYear();
                var m = "0" + (date.getMonth() + 1);
                var d = "0" + date.getDate();
                return (
                    y +
                    "" +
                    m.substring(m.length - 2, m.length) +
                    "" +
                    d.substring(d.length - 2, d.length)
                );
            }
            var date1 = vertDate(myDate);

            var params = {
                obj: obj,
                begin_time: date1 + "-091000",
            };

            var _this = this;
            _this.zs = [];
            getYunSpjToSf(params).then((res) => {
                _this.zs = [];
                this.$nextTick(() => {
                    setTimeout(function () {
                        if (res.data.err == 0) {
                            response = res.data.data;

                            var lenInfo = 20;
                            var zsQin = "0.00";
                            // for (var j = 0; j < lenInfo; j++) {
                            //     // _this.zs.push(zsQin);
                            //     _this.zs = _this.zs.concat(zsQin);
                            // }
                            var zsInfo;
                            for (var i = 0; i < response.length; i++) {
                                zsInfo = response[i][1].toFixed(2);
                                // _this.zs.push(zsInfo);
                                _this.zs = _this.zs.concat(zsInfo);
                            }
                        } else {
                            _this.zs = [];
                        }
                        setTimeout(function () {
                            // _this.drawLine();
                        });
                    });
                });
            });
        },
        /*弹窗显示*/
        showDialog() {
            this.dialogVisible = true;
        },
        /*弹窗关闭*/
        closeDialog() {
            this.dialogVisible = false;
        }

    },
};
</script>
